<template>
    <div class="imgLoader-container">
        <img v-if="!everythingDone" :src="placeHolder" alt="" class="placeholder">
        <img @load="handleLoad" :src="src" alt="" class="origin" 
        :style="{ opacity: originOpacity,transition: `${duration}ms` }">
    </div>
</template>

<script>
export default {
    props: {
        src: {
            type: String,
            required: true,
        },
        placeHolder: {
            type: String,
            required: true,
        },
        duration: {
            type: Number,
            default: 500,
        }
    },
    data() {
        return {
            originLoaded: false,
            everythingDone: false,
        }
    },
    computed: {
        originOpacity() {
            return this.originLoaded ? 1 : 0;
        },
    },
    methods: {
        handleLoad() {
            this.originLoaded = true;
            console.log("jiazai");
            setTimeout(()=>{
                this.everythingDone=true;
                this.$emit("load");
            },this.duration)
        }
    }
}
</script>

<style lang="less" scoped>
@import "../style/mixin.less";

.imgLoader-container {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;

    img {
        .self-fill();
        object-fit: cover;
    }

    .placeholder {
        filter: blur(2vw);
    }
}
</style>